import { useEffect } from 'react';
import { AwaitUserAuth } from 'components/AwaitUserAuth';
import { useApi, useApplicationState } from 'lib/contexts/ApplicationState';
import { useRouter } from 'next/router';
import { userViewableTeams } from 'lib/helpers';
import { useCreateNewTeamModal } from 'components/UpgradeModal';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { trackClickSignupEvent } from 'lib/hooks/useEventTracking';
import { LoadingOverlay } from 'components/LoadingOverlay';

/**
 * For anonymous users:
 * - Redirect to HubSpot Gondola for Business page
 * For logged-in non-team users:
 * - Pop up the create team modal
 * For logged-in team users:
 * - Redirect to /teams/:teamId/projects for their first team
 */
const TeamsPage = () => {
  const { currentUser, isAuthed } = useApplicationState();
  const router = useRouter();
  const { showCreateNewTeamModal } = useCreateNewTeamModal();
  const API = useApi();
  useEffect(() => {
    if (isAuthed && !currentUser && API) {
      trackClickSignupEvent(API, 'teams-redirect');
      router.push('https://on.gondola.cc/business');
      return;
    }

    if (currentUser && userViewableTeams(currentUser)?.length) {
      const teamId = userViewableTeams(currentUser)?.[0]?.id;
      if (!teamId) {
        router.push('/303');
      } else {
        router.push(`/teams/${teamId}`);
      }
    } else if (currentUser && !userViewableTeams(currentUser)?.length) {
      showCreateNewTeamModal('Create a team to get started',
        (teamId: number) => {
          router.push(`/teams/${teamId}/billing`);
        },
        () => {
          // On cancel, go back to the previous page
          router.back();
        });
    }
  }, [isAuthed, currentUser, router, API]);

  if (isAuthed && !currentUser) {
    return null;
  }

  // the title and description will only be displayed for logged out users
  return (
    <>
      <GondolaHead
        title="Gondola for Business"
        description="Hire top talent, track performance, and manage content -- all in one place."
        url="https://gondola.cc/teams"
      />
      <AwaitUserAuth>
        <LoadingOverlay open />
      </AwaitUserAuth>
    </>
  );
};

export default TeamsPage;
